<h1 mat-dialog-title>Alterar Promoção Demanda</h1>
<mat-divider></mat-divider>
<div mat-dialog-content style="width: 700px;">
    <div class="row mt-4" *ngIf="!bAutenticado">
        <div class="col-sm">
            <mat-form-field appearance="outline" [floatLabel]="'always'">
                <mat-label>Senha master</mat-label>
                <input type="password" id="input_senha_master" matInput [(ngModel)]="senhaMaster" maxlength="50"
                    (keypress)="($event.charCode==13)?autenticarSenha():null" required>
            </mat-form-field>
        </div>

        <div class="col-auto">
            <button class="mt-4" mat-flat-button color="warn" (click)="cancelar()">
                <mat-icon>close</mat-icon> Cancelar
            </button>
        </div>
        <div class="col-auto">
            <button class="mt-4" mat-flat-button color="primary" (click)="autenticarSenha()">
                <mat-icon>check</mat-icon> Autenticar
            </button>
        </div>
    </div>

    <div *ngIf="bAutenticado">
        <form [formGroup]="taxaForm">
            <div class="row">
                <div class="col-auto">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Taxa (%)</mat-label>
                        <input type="number" matInput formControlName="taxa" required>
                        <mat-error *ngIf="f.taxa.errors">
                            Campo obrigatório (Maior ou igual a 1 e menor do que 99)
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </form>

        <mat-divider></mat-divider>

        <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
            <button mat-flat-button color="warn" (click)="cancelar()">
                <mat-icon>clear</mat-icon> Cancelar
            </button>
            <button mat-flat-button color="primary" (click)="confirmarAlteracaoDemanda()">
                <mat-icon>check</mat-icon> Confirmar nova taxa
            </button>
        </section>
    </div>
</div>